import { getSafeUrl } from "../../utils/helpers.js";
import { Fragment, useEffect, useState } from "react";
import deleteImage from "../../assets/images/delete.png";
import editImage from "../../assets/images/Edit.png";
import CartBack from "../../assets/images/cart-back.png";
import CloseCircle from "../../assets/images/close-circle.svg";
import Cartplan1 from "../../assets/images/cartplan1.svg";
import Del from "../../assets/images/del.svg";
import Edit from "../../assets/images/Edit.svg";
import CartCoupon from "../../assets/images/cart-coupon.svg";
import { useUserState } from "../../Contexts/UserContext";
import axios from "axios";
import { Button, Spinner } from "react-bootstrap";
import ModalComponent from "../common/ModalComponents";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Loader from "../common/Loader";
import { buildInitialDistribution, buildMonthlySchedules } from "../../utils/paymentDistributionHelper";

import FurnitureBackImg from "../../assets/images/furniture-back.png";
import Cart1Img from "../../assets/images/cart1.png";
import Cart2Img from "../../assets/images/cart2.png";
import Cart3Img from "../../assets/images/cart3.png";
import uploadImage from "../../assets/images/upload.png";
import addUserImage from "../../assets/images/add-user-icon.png";
import HouseDummyImg from "../../assets/images/houseDummy.webp";

const AllDataInCart = () => {
  const { user, isLoggedIn } = useUserState();
  const navigate = useNavigate();
  const location = useLocation();
  const [cartData, setCartData] = useState([]);
  const [finalCartData, setFinalCartData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [totalAmountDays, setTotalAmountDays] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [cardData, setCardData] = useState([]);
  const [isChecked, setIsChecked] = useState(true);
  const [subscriptionType, setSubscriptionType] = useState("monthly");
  const [monthlypay, setMonthlypay] = useState(null);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [securityInsuranceFee, setSecurityInsuranceFee] = useState(null);
  const [paymentBreakdown, setPaymentBreakdown] = useState({
    oneTimeCharges: {},
    recurringCharges: {},
    firstPaymentDistribution: {},
    monthlySchedules: [],
    totalNow: 0,
    recurringMonthlyTotal: 0
  });
  const fromDate = location?.state?.startDate;
  const toDate = location?.state?.endDate;
  const storeId = location?.state?.storeId;

  const [termConModal, setTermConModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [bookingTermsModal, setBookingTermsModal] = useState(false);
  const [proceedAmount, setProceesAmount] = useState();
  const [days, setDays] = useState(null);
  const [noOfMonths, setNoOfMonths] = useState(null);
  const [noOfRemaingDays, setNoOfRemainingDays] = useState();
  const [totalMonths, setTotalMonths] = useState();
  const [openCleaningDetails, setOpenCleaningDetails] = useState(false);
  const [minimizeView, setMinimizeView] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [cartId, setCartId] = useState("");
  const [houseId, setHouseId] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const [urlData, setUrlData] = useState(null);
  const [tenantList, setTenantList] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [isDisabledButtonIcons, setIsDisabledButtonIcons] = useState(false);
  const [furDelPrice, setFurDelPrice] = useState(0);
  const [deliveryDetail, setDeliveryDetail] = useState({});
  const [formattedFurnData, setFormattedFurnData] = useState({});
  const [bookingCharges, setBookingCharges] = useState({});
  const [newTenant, setNewTenant] = useState({
    id: null,
    name: null,
    age: null,
    gender: null,
    phone: null,
    email: null,
    document: null,
    main_cart_id: cartId,
  });
  const [inputTenant, setInputTenant] = useState(true);
  const [error, setError] = useState(null);
  const [editedTenant, setEditedTenant] = useState({
    id: null,
    name: null,
    age: null,
    gender: null,
    phone: null,
    email: null,
    document: null,
  });
  const [requiredField, setRequiredField] = useState({
    name: "",
    age: "",
    gender: "",
    phone: "",
    document: "",
  });
  const [isTenantList, setIsTenantList] = useState(false);
  //function for calcuating booking charges
  console.log('finalCartData', finalCartData);

  const calculateProcessAmount = (baseAmount) => {
    const amount = Number(baseAmount) || 0;
    const percentage = Number(bookingCharges) || 0;
    console.log("a", amount, percentage);

    let finalAmount = amount;
    if (percentage > 0) {
      const chargeAmount = (amount * percentage) / 100;
      finalAmount = amount + chargeAmount;
    }
    return Number(finalAmount).toFixed(2);
  };
  console.log('proceedAmount', proceedAmount);

  const fetchBookingCharges = async () => {
    const response = await axios.get(
      `${import.meta.env.VITE_APP_BASE_URL}/api/admin/booking-charges/${user?.currentRole}`,
    );
    setBookingCharges(response.data.data[0].percentage || 0);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const cart = params.get("cart");
        const house = params.get("house");
        setCartId(cart);
        setHouseId(house);
        newTenant.main_cart_id = cartId;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchBookingCharges();
    fetchData();
  }, [location.search, user?.currentRole]);

  if (!isLoggedIn) {
    navigate("/login");
  }
  function calculateDateDifference(startDate, endDate) {
    const differenceMs = endDate - startDate;
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24)) + 1;
    setDays(differenceDays);
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    let diffYear = endDate.getFullYear() - startDate.getFullYear();
    let diffMonth = endDate.getMonth() - startDate.getMonth();
    let months = diffYear * 12 + diffMonth;
    let totalDaysInLstMonth = new Date(
      endDate.getFullYear(),
      endDate.getMonth() + 1,
      0,
    ).getDate();
    if (months < 0 || (months === 0 && endDay < startDay)) {
      months += 12;
    }
    let remainingDays = endDay - startDay + 1;
    if (remainingDays === totalDaysInLstMonth) {
      (months++, (remainingDays = 0));
    }
    if (remainingDays < 0) {
      months--;
      const tempDate = new Date(endDate);
      tempDate.setMonth(endDate.getMonth() - 1);
      remainingDays =
        new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0).getDate() -
        startDay +
        endDay +
        1;
    }
    console.log(
      "months + remainingDays / totalDaysInLstMonth",
      months,
      remainingDays,
      totalDaysInLstMonth,
    );

    setTotalMonths(months + remainingDays / totalDaysInLstMonth);
    setNoOfMonths(months);
    setNoOfRemainingDays(remainingDays);
    return {
      days: differenceDays,
      months: months,
      remainingDays: remainingDays,
    };
  }
  // let counter = 1;
  const getSecurityInsuranceFee = async () => {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL}api/admin/get/security-insurance-fee`,
        { headers: headers },
      );
      if (res?.data?.data) {
        const fee = parseFloat(res.data.data.security_insurance_fee);
        console.log('fee', fee);

        setSecurityInsuranceFee(fee);
        setInputData((prev) => ({
          ...prev,
          securityPrice: fee,
        }));
      }
    } catch (err) {
      console.log("Error while fetching security insurance fee", err?.message);
    }
  };
  const calculateInstallments = (
    startDate,
    endDate,
    totalAmount,
    securityDeposit,
    nonRefundableFee = 0,
  ) => {
    const { months, remainingDays } = calculateDateDifference(
      startDate,
      endDate,
    );
    let monthsRemaining = months;
    const installments = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const daysInMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0,
      ).getDate();
      let daysToUse = monthsRemaining > 0 ? daysInMonth : remainingDays;
      monthsRemaining--;
      const installmentAmount = (daysToUse / daysInMonth) * totalAmount;
      const year = currentDate.getFullYear();
      const monthName = `${currentDate.toLocaleString("default", {
        month: "long",
      })}-${year}`;
      if (currentDate.getTime() === startDate.getTime()) {
        installments.push({
          // month: `${monthName}( with security )`,
          month: `${monthName}`,
          amount: (
            installmentAmount +
            securityDeposit +
            Number(nonRefundableFee)
          ).toFixed(2),
        });
      } else {
        installments.push({
          month: monthName,
          amount: (installmentAmount + securityDeposit).toFixed(2),
        });
      }
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { installments, remainingDays, months };
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const headers = {
    Authorization: user?.token,
  };
  console.log("finalCartData", finalCartData, furDelPrice);

  // const FetchData = async () => {
  //   const baseCartUrl = `${
  //     import.meta.env.VITE_APP_BASE_URL
  //   }/api/cart/get-by-house/${cartId}/${houseId}`;
  //   const baseCardUrl = `${
  //     import.meta.env.VITE_APP_BASE_URL
  //   }/api/payment-method/get-list`;
  //   let baseGetTenatUrl = `${
  //     import.meta.env.VITE_APP_BASE_URL
  //   }/api/relo/getTenant/${cartId}`;
  //   try {
  //     const res = await axios.get(baseCartUrl, { headers });
  //     const cardRes = await axios.get(baseCardUrl, { headers });
  //     const tenantRes =
  //       user?.currentRole === "relo"
  //         ? await axios.get(baseGetTenatUrl, { headers })
  //         : null;
  //     // const furData = await axios.get(basefurdelvprice, { headers });
  //     // console.log('furData',furData);

  //     if (res.status === 200 && cardRes.status === 200) {
  //       let cartItems = res.data.data;
  //       setCardData(cardRes?.data?.data?.data);
  //       setCartData(cartItems);
  //     }
  //     if (tenantRes.status === 200) {
  //       setTenantList(tenantRes?.data?.data);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const FetchData = async () => {
    const baseCartUrl = `${import.meta.env.VITE_APP_BASE_URL
      }/api/cart/get-by-house/${cartId}/${houseId}`;
    const baseCardUrl = `${import.meta.env.VITE_APP_BASE_URL
      }/api/payment-method/get-list`;
    const baseGetTenantUrl = `${import.meta.env.VITE_APP_BASE_URL
      }/api/relo/getTenant/${cartId}`;

    try {
      // Step 1: Fetch cart + card in parallel
      const [res, cardRes] = await Promise.all([
        axios.get(baseCartUrl, { headers }),
        axios.get(baseCardUrl, { headers }),
      ]);

      const tenantRes =
        user?.currentRole === "relo" || user?.currentRole === "tenant"
          ? await axios.get(baseGetTenantUrl, { headers })
          : null;

      if (res.status === 200 && cardRes.status === 200) {
        const cartItems = res.data.data;
        const furnitureCarts = cartItems?.mainCart?.furnitureCarts ?? [];
        console.log("==1", furnitureCarts);

        const formattedFur = {
          houseware: furnitureCarts?.filter(
            (item) =>
              item.is_package_item && item.furniture_data?.type === "houseware",
          ),
          furniture: furnitureCarts?.filter(
            (item) =>
              item.is_package_item && item.furniture_data?.type !== "houseware",
          ),
          additional_items: furnitureCarts?.filter(
            (item) => !item.is_package_item,
          ),
        };
        setFormattedFurnData({
          packageName:
            formattedFur?.furniture.length > 0
              ? formattedFur.furniture[0].furniture_category_data.name
              : "",
          ...formattedFur,
        });
        setCardData(cardRes?.data?.data?.data);
        setCartData(cartItems);
        const categoryId = furnitureCarts[0]?.furniture_category_id;
        const planId = furnitureCarts[0]?.furniture_category_data?.id;
        if (categoryId) {
          const getAllCompanyUrl = `${import.meta.env.VITE_APP_BASE_URL
            }/api/user/getAllCompany/furniture_company?categoryId=${categoryId}&houseId=${houseId}&furniture_type=${planId}`;
          const companyRes = await axios.get(getAllCompanyUrl, { headers });
          if (companyRes.status === 200) {
            const allCompanies = companyRes.data.data;
            // setCompanyList(allCompanies);d
            const companyIdsInCart = new Set(
              furnitureCarts.map((item) => item.furniture_data?.created_by),
            );
            const matchedCompanies = allCompanies.filter(
              (comp) =>
                companyIdsInCart.has(String(comp.id)) &&
                comp.companyId === storeId,
            );
            if (allCompanies.length > 0) {
              // setSelectedCompany(matchedCompanies[0]);
              const {
                furniture_delivery_price,
                furniture_delivery_extra_price,
                city_extra_price,
              } = matchedCompanies[0];
              setDeliveryDetail({
                delivery_price: furniture_delivery_price,
                delivery_extra_price: furniture_delivery_extra_price,
                city_price: city_extra_price,
              });
              setFurDelPrice(
                furniture_delivery_price +
                furniture_delivery_extra_price +
                city_extra_price,
              );
            } else {
              console.warn("No matching company found for cart items");
            }
          }
        }
      }

      if (tenantRes?.status === 200) {
        setTenantList(tenantRes.data.data);
      }
    } catch (error) {
      console.log("FetchData error:", error);
    }
  };

  const calculateCartTotal = (data, isChecked) => {
    const mainCart = data?.mainCart;
    if (!mainCart || !mainCart.furnitureCarts) {
      return null; // or handle the absence of mainCart as appropriate
    }

    const {
      furnitureCarts,
      cleaningServiceCarts,
      house_data: houseData,
      parent_cart_id,
    } = mainCart;

    const {
      name: houseName = "",
      monthly_price: housePrice = 0,
      security_prices: securityPrice = 0,
      non_refundable_fee: nonRefundableFee = 0,
      houseImages = [],
    } = houseData || {};
    const owner_offered_price =
      mainCart?.house_data?.priceNegotiateRequests[0]?.negotiationData[0]
        ?.owner_offered_price;
    const cust_offered_price =
      mainCart?.house_data?.priceNegotiateRequests[0]?.negotiationData[0]
        ?.cust_offered_price;
    const cartId =
      furnitureCarts?.length > 0
        ? furnitureCarts[0].main_cart_id
        : cleaningServiceCarts[0].main_cart_id;
    const houseImage = houseImages.length > 0 ? houseImages[0].imageUrl : null;

    let furnitureTotalPrice = 0;
    let cleaningTotalPrice = 0;

    const furnitureNames = [];
    const cleaningNames = [];

    for (const item of furnitureCarts) {
      const price = Number(item.furniture_data.price);
      const quantity = item.quantity;
      furnitureTotalPrice += price * quantity;
      furnitureNames.push(item.furniture_category_data.name);
    }
    for (const service of cleaningServiceCarts) {
      const price = Number(service.cleaning_service_data.price);
      const frequency = service.frequency;
      cleaningTotalPrice += price * frequency;

      cleaningNames.push(service.cleaning_service_data.name);
    }
    const baseHousePrice = Number(
      owner_offered_price || cust_offered_price || housePrice,
    );
    const housePriceWithBooking = Number(
      calculateProcessAmount(baseHousePrice),
    );

    const subTotal = (
      parseFloat(furnitureTotalPrice + furDelPrice) +
      parseFloat(cleaningTotalPrice) / parseFloat(totalMonths) +
      parseFloat(housePriceWithBooking)
    ).toFixed(2);
    const subTotalWithoutBookingFee = (
      parseFloat(furnitureTotalPrice + furDelPrice) +
      parseFloat(cleaningTotalPrice) / parseFloat(totalMonths) +
      parseFloat(baseHousePrice)
    ).toFixed(2);

    const total = (
      parseFloat(subTotal) +
      parseFloat(securityInsuranceFee) +
      parseFloat(nonRefundableFee || 0)
    ).toFixed(2);
    console.log('totald', total, subTotal, securityInsuranceFee, nonRefundableFee);

    return {
      cartId,
      parent_cart_id,
      furniture_name: furnitureNames,
      furniture_total_price: furnitureTotalPrice,
      furniture_image:
        furnitureCarts[0]?.furniture_data.furniture_images[0]?.imageUrl,
      cleaning_name: cleaningNames,
      cleaning_total_price: cleaningTotalPrice,
      house_name: houseName,
      house_price: owner_offered_price || cust_offered_price || housePrice,
      houseImage: houseImage,
      security_price: securityInsuranceFee,
      non_refundable_fee: nonRefundableFee,
      furDelPrice,
      subTotal,
      subTotalWithoutBookingFee,
      total,
    };
  };
  useEffect(() => {
    if (user?.token) {
      cartId && FetchData();
    }
  }, [user?.token, cartId, showModal]);
  useEffect(() => {
    try {
      if (Object.prototype.hasOwnProperty.call(cartData, "mainCart")) {
        const calculatedCartTotal = calculateCartTotal(cartData, isChecked);
        console.log('calculatedCartTotal', calculatedCartTotal);

        setFinalCartData(calculatedCartTotal);

        const initialDistribution = buildInitialDistribution({
          monthlyRent: calculatedCartTotal?.house_price,
          securityFee: calculatedCartTotal?.non_refundable_fee,
          bookingChargesPercent: bookingCharges,
          cleaningTotal: calculatedCartTotal?.cleaning_total_price,
          subscriptionType: isChecked ? "monthly" : "one_time",
          totalMonths: totalMonths,
        });

        const schedules = buildMonthlySchedules({
          startDate: fromDate,
          endDate: toDate,
          monthlyRent: calculatedCartTotal?.house_price,
          securityInsurance: securityInsuranceFee,
        });

        const breakdown = {
          firstPaymentDistribution: initialDistribution,
          monthlySchedules: schedules,
        };
        setPaymentBreakdown(breakdown);

        const calculatedTotalAmountDays =
          (calculatedCartTotal?.subTotal * days) / 30;

        // setTotalAmountDays(calculatedTotalAmountDays);
        // setTotalAmount(
        //   (
        //     calculatedTotalAmountDays + calculatedCartTotal?.security_price
        //   ).toFixed(2)
        // );

        const { installments, remainingDays, months } = calculateInstallments(
          new Date(fromDate),
          new Date(toDate),
          calculatedCartTotal?.subTotal,
          securityInsuranceFee,
          calculatedCartTotal?.non_refundable_fee,
        );
        setNoOfMonths(months);
        setNoOfRemainingDays(remainingDays);
        console.log('setMonthlypay', installments);

        setMonthlypay(installments);
        const baseAmount = installments
          .reduce((acc, { amount }) => acc + parseFloat(amount), 0)
          .toFixed(2);
        console.log('baseamount', baseAmount);

        setProceesAmount(baseAmount);
        setTotalAmountDays(installments[0].amount);
        console.log("installments", installments);

        setTotalAmount(
          installments
            .reduce((acc, { amount }) => acc + parseFloat(amount), 0)
            .toFixed(2),
        );
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, [cartData, days, furDelPrice, isChecked, bookingCharges, securityInsuranceFee]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    if (isChecked) {
      const baseAmount = parseFloat(finalCartData?.total).toFixed(2);
      console.log('monthlypayment', finalCartData?.total);

      setProceesAmount(baseAmount);
      setSubscriptionType("monthly");
    } else {
      const baseAmount = parseFloat(totalAmount).toFixed(2);
      setProceesAmount(baseAmount);
      setSubscriptionType("one_time");
    }
  }, [isChecked, totalAmount, finalCartData]);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  useEffect(() => {
    if (noOfMonths === 1 && noOfRemaingDays === 0) {
      setIsChecked(false);
    }
  }, [noOfMonths, noOfRemaingDays]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
    getSecurityInsuranceFee();
  }, []);
  const headerJson = {
    "Content-Type": "application/json",
    Authorization: user?.token,
  };
  const headersFormData = {
    "Content-Type": "multipart/form-data",
  };
  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];
      let formData = new FormData();
      formData.append("tenant_document", file);
      let res = await axios.post(
        `${import.meta.env.VITE_APP_BASE_URL}/api/relo/upload`,
        formData,
        { headers: headersFormData },
      );
      if (isEditing) {
        const updatedTenantList = [...tenantList];
        updatedTenantList[isEditing].document = res?.data?.data?.docUrl;
        setTenantList(updatedTenantList);
      } else {
        setUrlData(
          import.meta.env.VITE_APP_BASE_URL + "/" + res?.data?.data?.docUrl,
        );
        newTenant.document = res?.data?.data?.docUrl;
      }
    } catch (err) {
      return;
    }
  };
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^[0-9]{8,10}$/; // Adjust as needed for different phone formats
  // const handleAddTenant = async () => {
  //   setIsDisabledButtonIcons(true);
  //   let validData = [...tenantList, newTenant];
  //   try {
  //     console.log("asss", requiredField);
  //     // Validate the tenant name
  //     if (
  //       !newTenant?.name ||
  //       !newTenant.name.trim() ||
  //       !validData.length === 1
  //     ) {
  //       // setError("Name is required.");
  //       setRequiredField({ name: "Name is required" });
  //       setIsDisabledButtonIcons(false);
  //       return;
  //     }
  //     setRequiredField({
  //       name: "",
  //       age: "",
  //       gender: "",
  //       phone: "",
  //       document: "",
  //     });
  //     if (validData.length < 2) {
  //       if (!newTenant?.name || !newTenant.name.trim()) {
  //         requiredField.name = "Name is required";
  //       } else {
  //         requiredField.name = "";
  //       }
  //       if (newTenant.age !== '') {
  //         requiredField.age = "Age is required";
  //       } else {
  //         requiredField.age = "";
  //       }
  //       if (1 < newTenant.age > 110) {
  //         requiredField.age = "Age should be between 1 and 110";
  //       } else {
  //         requiredField.age = "";
  //       }
  //       if (!newTenant.gender) {
  //         requiredField.gender = "Gender is required";
  //       }
  //       if (!newTenant.phone) {
  //         requiredField.phone = "Contact info is required";
  //
  //       }
  //       if (!newTenant.document) {
  //         requiredField.document = "Document is required";
  //       }
  //       setRequiredField(requiredField);
  //       return;
  //     }

  //     const baseAddTenantUrl = `${
  //       import.meta.env.VITE_APP_BASE_URL
  //     }/api/relo/addTenant`;

  //     // Perform API call to add tenant
  //     setError(null);
  //
  //     const res = await axios.post(
  //       baseAddTenantUrl,
  //       { ...newTenant, main_cart_id: cartId },
  //       { headers: headerJson }
  //     );

  //     if (res.status === 201) {
  //       setTenantList(res.data.data); // Update tenant list with new data
  //       setNewTenant({
  //         id: "",
  //         name: "",
  //         age: "",
  //         gender: "",
  //         phone: "",
  //         document: "",
  //       }); // Reset new tenant form
  //       setUrlData(null); // Clear URL data if needed
  //     } else {
  //       // Handle unexpected status codes
  //       console.error("Failed to add tenant:", res.status, res.data);
  //       alert("Failed to add tenant. Please try again later.");
  //     }
  //   } catch (error) {
  //     console.log("Error while adding tenant:", error);
  //     alert(
  //       error.response?.data?.message ||
  //         "Failed to add tenant. Please try again later."
  //     );
  //   } finally {
  //     setIsDisabledButtonIcons(false); // Ensure the button is re-enabled
  //   }
  // };
  const handleAddTenant = async () => {
    setIsDisabledButtonIcons(true);

    // Validate form
    const errors = validateTenant(newTenant, tenantList);

    if (Object.keys(errors).length > 0) {
      setRequiredField(errors);
      setIsDisabledButtonIcons(false);
      return;
    }

    try {
      const baseAddTenantUrl = `${import.meta.env.VITE_APP_BASE_URL
        }/api/relo/addTenant`;

      const res = await axios.post(
        baseAddTenantUrl,
        { ...newTenant, main_cart_id: cartId },
        { headers: headerJson },
      );

      if (res.status === 201) {
        setTenantList(res.data.data);
        setNewTenant({
          name: "",
          age: "",
          gender: "",
          phone: "",
          email: "",
          document: "",
        });
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to add tenant");
    }

    setIsDisabledButtonIcons(false);
  };
  const validateTenant = (tenant, tenantList) => {
    const errors = {};

    // Name
    if (!tenant.name?.trim()) {
      errors.name = "Name is required";
    } else if (
      tenant.name.trim().length < 3 ||
      tenant.name.trim().length > 25
    ) {
      errors.name = "Name must be between 3 and 25 characters";
    }

    // Age
    if (!tenant.age) {
      errors.age = "Age is required";
    } else if (tenant.age < 1 || tenant.age > 110) {
      errors.age = "Age should be between 1 and 110";
    }

    // Gender
    if (!tenant.gender) {
      errors.gender = "Gender is required";
    }

    // Phone
    if (!tenant.phone) {
      errors.phone = "Contact is required";
    } else if (!phoneRegex.test(tenant.phone)) {
      errors.phone = "Invalid phone number";
    }

    // Email
    if (!tenant.email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(tenant.email)) {
      errors.email = "Invalid email";
    }

    return errors;
  };

  const clearError = (field) => {
    setRequiredField((prev) => ({ ...prev, [field]: "" }));
  };

  // Regular expressions for email and phone number

  const handleEditTenant = (index) => {
    setIsEditing(index);
    setEditedTenant({ ...tenantList[index] }); // Set the selected tenant for editing
    setInputTenant(false);
  };

  const handleUpdateTenant = async (index) => {
    const updateData = { ...editedTenant }; // Use the edited data
    setIsDisabledButtonIcons(true);
    setRequiredField({});
    try {
      let validation = {};
      // Validation
      if (!updateData.name.trim()) {
        // setError("Name is required.");
        validation.name = "Name is required.";
        return;
      }
      if (
        updateData?.name?.trim().length < 3 ||
        updateData?.name?.trim().length > 25
      ) {
        validation.name = "Name must be between 3 and 25 characters";
        return;
      }
      if ((!updateData.age && updateData?.age < 1) || updateData?.age > 110) {
        validation.age = "Age should be between 1 and 110";
      }

      setError(null);
      for (let key in updateData) {
        if (
          typeof updateData[key] === "string" &&
          updateData[key].trim() === ""
        ) {
          updateData[key] = null;
        }
      }
      if (updateData.phone && !phoneRegex.test(updateData.phone)) {
        validation.phone = "Invalid phone number";
      }
      if (updateData.email && !emailRegex.test(updateData.email)) {
        validation.email = "Invalid email address";
      }
      if (Object.values(validation).some((field) => field !== "")) {
        setRequiredField(validation);
        setIsDisabledButtonIcons(false);
        return;
      }
      // API call to update tenant information
      const response = await fetch(
        `${import.meta.env.VITE_APP_BASE_URL}/api/relo/updateTenant/${updateData.id
        }`,
        {
          method: "POST",
          headers: headerJson,
          body: JSON.stringify(updateData),
        },
      );
      setRequiredField({});
      if (response.ok) {
        const updatedTenantList = [...tenantList];
        updatedTenantList[index] = updateData; // Update the tenant list with the edited data
        setTenantList(updatedTenantList);
        setIsEditing(null); // Exit edit mode
      } else {
        const errorText = await response.text();
        console.error("Failed to update tenant:", errorText);
        // setError("Failed to update tenant. Please try again.");
      }
    } catch (error) {
      console.error("Error updating tenant:", error);
      // setError("An error occurred. Please try again.");
    } finally {
      setIsDisabledButtonIcons(false); // Re-enable buttons/icons after the update
      setInputTenant(true);
    }
  };

  const handleDeleteTenant = async (index) => {
    setIsDisabledButtonIcons(true);
    try {
      const updateData = tenantList[index];
      await fetch(
        `${import.meta.env.VITE_APP_BASE_URL}/api/relo/deleteTenant`,
        {
          method: "POST",
          headers: headerJson,
          body: JSON.stringify({ id: updateData.id }),
        },
      );
      const updatedTenantList = tenantList.filter((_, i) => i !== index);
      setTenantList(updatedTenantList);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDisabledButtonIcons(false); // Re-enable button/icons after the update is complete
    }
  };
  const checkCompleteObject = (array) => {
    for (const obj of array) {
      // Check that 'name', 'gender', 'phone', and 'email' are non-null and non-empty
      if (obj.name && obj.gender && obj.phone && obj.email) {
        // Check that all of these values are non-null and non-empty (trimmed for strings)
        const isValid = [obj.name, obj.gender, obj.phone, obj.email].every(
          (value) => {
            return (
              value !== null &&
              (typeof value !== "string" || value.trim() !== "")
            );
          },
        );
        if (isValid) {
          return true; // Found a valid object
        }
      }
    }
    return false; // No valid object found
  };

  useEffect(() => {
    if (!checkCompleteObject(tenantList) && !!tenantList.length) {
      // If all objects in the list have valid data, proceed with the update
      setIsTenantList(true);
    } else {
      setIsTenantList(false);
      // alert("Please fill in all the fields");
    }
  }, [tenantList]);

  const furnitureTotal = formattedFurnData?.furniture?.reduce(
    (sum, item) => sum + parseFloat(item.price || 0),
    0,
  );
  const furnitureTotalQuantity = formattedFurnData?.furniture?.reduce(
    (sum, item) => sum + parseFloat(item.quantity || 0),
    0,
  );

  const housewareTotal = formattedFurnData?.houseware?.reduce(
    (sum, item) => sum + parseFloat(item.price || 0),
    0,
  );
  const housewareTotalQuantity = formattedFurnData?.houseware?.reduce(
    (sum, item) => sum + parseFloat(item.quantity || 0),
    0,
  );

  const handleProceedCheckout = () => {
    if (!acceptTerms) {
      setTermsError(true);
      return;
    }
    handleOpenModal();
  };
  console.log("finalCartData", proceedAmount);

  return (
    <Fragment>
      <div className="banner-section customise-furniture-back">
        <img src={FurnitureBackImg} alt="assets" />
      </div>

      <div className="cart-sec">
        <div className="container-fluid my-container">
          {finalCartData ? (
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <h4>
                  Your selection ({" "}
                  {finalCartData?.furniture_total_price === 0 ? "2" : "3"} items
                  )
                </h4>
                <div
                  className="accordion accordion-summary"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p>Property Summary Level</p>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <ul>
                          <li>
                            <img
                              src={
                                finalCartData.houseImage
                                  ? getSafeUrl(finalCartData?.houseImage)
                                  : Cartplan1
                              }
                              alt=""
                              onError={(e) => {
                                e.target.src = HouseDummyImg;
                              }}
                            />
                            {finalCartData?.house_name}
                          </li>
                          <li>
                            $
                            {(
                              finalCartData?.house_price * (totalMonths || 1)
                            ).toFixed(2)}{" "}
                            {/* <span>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M18.8484 9.14001L18.1984 19.21C18.0884 20.78 17.9984 22 15.2084 22H8.78844C5.99844 22 5.90844 20.78 5.79844 19.21L5.14844 9.14001"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.3281 16.5H13.6581"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.5 12.5H14.5"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span> */}
                          </li>
                        </ul>
                      </button>
                    </h2>
                    <ul className="m-0">
                      <p>Detailed Level</p>
                      <div className="table-responsive">
                        <table className="table m-0">
                          <thead>
                            <tr>
                              <th scope="col">Property Name</th>
                              <th scope="col">Lease Term</th>
                              <th scope="col">Monthly Rent</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td> {finalCartData?.house_name}</td>
                              <td>
                                {noOfMonths}{" "}
                                {noOfMonths === 1 ? "Month" : "Months"}{" "}
                                {noOfRemaingDays > 0 &&
                                  `and ${noOfRemaingDays} Day${noOfRemaingDays !== 1 ? "s" : ""
                                  }`}{" "}
                              </td>
                              <td> ${finalCartData?.house_price}/per month</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ul>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p>Cleaning Summary Level</p>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <ul>
                          <li>
                            <img src={Cartplan1} alt="assets" /> Cleaning Plan
                            Details
                          </li>
                          <li>
                            ${finalCartData?.cleaning_total_price}
                            {/* <span>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M18.8484 9.14001L18.1984 19.21C18.0884 20.78 17.9984 22 15.2084 22H8.78844C5.99844 22 5.90844 20.78 5.79844 19.21L5.14844 9.14001"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.3281 16.5H13.6581"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.5 12.5H14.5"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span> */}
                          </li>
                        </ul>
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="table-responsive">
                          <table className="table m-0">
                            <thead>
                              <tr>
                                <th scope="col">Cleaning Plan Name</th>
                                <th scope="col">Cleaning Frequency</th>
                                <th scope="col">Price Per Plan</th>
                                <th scope="col">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cartData?.mainCart?.cleaningServiceCarts?.map(
                                (cartdata, key) => (
                                  <tr key={key}>
                                    <td>
                                      <img src={Cartplan1} alt="assets" />{" "}
                                      {cartdata.cleaning_service_data.name}
                                    </td>
                                    <td>{cartdata.frequency}</td>
                                    <td>
                                      ${cartdata.cleaning_service_data.price}
                                      /per plan
                                    </td>
                                    <td>
                                      $
                                      {cartdata.frequency *
                                        cartdata.cleaning_service_data.price}
                                    </td>
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p>Booking Fee Summary Level</p>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="true"
                        aria-controls="collapseFive"
                      >
                        <ul>
                          <li>Booking Fee Summary</li>
                          <li>
                            $
                            {(
                              ((finalCartData?.house_price || 0) *
                                (totalMonths || 1) *
                                bookingCharges) /
                              100
                            ).toFixed(2)}{" "}
                          </li>
                        </ul>
                      </button>
                    </h2>
                    <ul>
                      <p>Detailed Level</p>
                      <div className="table-responsive">
                        <table className="table m-0">
                          <thead>
                            <tr>
                              <th scope="col">
                                Detailed Booking Fee{" "}
                                <i
                                  title={`${bookingCharges}% of Monthly Rental fee.`}
                                  className="fa-solid fa-circle-info"
                                ></i>
                              </th>
                              <th scope="col">Lease Term</th>
                              <th scope="col">Monthly Booking Fee</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td> {bookingCharges}%(Monthly Rental Fee)</td>
                              <td>
                                {noOfMonths}{" "}
                                {noOfMonths === 1 ? "Month" : "Months"}{" "}
                                {noOfRemaingDays > 0 &&
                                  `and ${noOfRemaingDays} Day${noOfRemaingDays !== 1 ? "s" : ""
                                  }`}{" "}
                              </td>
                              <td>
                                {" "}
                                $
                                {(Number(finalCartData?.house_price) *
                                  Number(bookingCharges)) /
                                  100}
                                /per month
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ul>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p>Security Fee One Time Non-Refundable</p>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="true"
                        aria-controls="collapseFive"
                      >
                        <ul>
                          <li>Security Fee (One Time Non-Refundable)</li>
                          <li>
                            ${finalCartData?.non_refundable_fee}
                          </li>
                        </ul>
                      </button>
                    </h2>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p>Security Fee Summary Level</p>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="true"
                        aria-controls="collapseFive"
                      >
                        <ul>
                          <li>Security Insurance</li>
                          <li>
                            $
                            {(
                              Number(securityInsuranceFee || 0) *
                              Number(totalMonths || 0)
                            ).toFixed(2)}
                          </li>
                        </ul>
                      </button>
                    </h2>
                    <ul>
                      <p>Detailed Level</p>
                      <div className="table-responsive">
                        <table className="table m-0">
                          <thead>
                            <tr>
                              <th scope="col">
                                Monthly Security Insurance{" "}
                                <i
                                  title={`Security fee per day: $${(securityInsuranceFee / 30).toFixed(2)}`}
                                  className="fa-solid fa-circle-info"
                                ></i>
                              </th>
                              <th scope="col">Lease Term</th>
                              <th scope="col">
                                Monthly Security Insurance Fee
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Security Insurance (Monthly)</td>
                              <td>
                                {noOfMonths}{" "}
                                {noOfMonths === 1 ? "Month" : "Months"}{" "}
                                {noOfRemaingDays > 0 &&
                                  `and ${noOfRemaingDays} Day${noOfRemaingDays !== 1 ? "s" : ""
                                  }`}{" "}
                              </td>
                              <td> ${securityInsuranceFee}/per month</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ul>
                  </div>
                  {finalCartData?.furniture_total_price > 0 && (
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          <ul>
                            <li>
                              <img src={Cart3Img} alt="assets" />{" "}
                              {finalCartData?.furniture_name[0] ||
                                "Furniture Plan Details"}
                            </li>
                            <li>
                              ${finalCartData?.furniture_total_price}/per month
                              {/* <span>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M18.8484 9.14001L18.1984 19.21C18.0884 20.78 17.9984 22 15.2084 22H8.78844C5.99844 22 5.90844 20.78 5.79844 19.21L5.14844 9.14001"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.3281 16.5H13.6581"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.5 12.5H14.5"
                                  stroke="#23262F"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span> */}
                            </li>
                          </ul>
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div className="table-responsive">
                            <table className="table m-0">
                              <thead>
                                <tr>
                                  <th scope="col"> Package Name</th>
                                  <th scope="col">Quantity</th>
                                  <th scope="col">Price</th>
                                  {/* <th scope="col">Price Monthly</th> */}
                                  {/* <th scope="col">Total</th> */}
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  <td colSpan={2}>
                                    <p>Furniture Items</p>
                                  </td>
                                  <td>
                                    <p>${furnitureTotal}</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <p>Houseware Items</p>
                                  </td>
                                  <td>
                                    <p>${housewareTotal}</p>
                                  </td>
                                </tr>

                                {formattedFurnData?.additional_items?.length >
                                  0 && (
                                    <>
                                      <tr>
                                        <td colSpan={3}>
                                          <strong>Additional Items</strong>
                                        </td>
                                      </tr>
                                      {formattedFurnData?.additional_items.map(
                                        (item, key) => (
                                          <tr key={`add-${key}`}>
                                            <td>
                                              <img
                                                src={
                                                  import.meta.env
                                                    .VITE_APP_BASE_URL +
                                                  (item.furniture_data
                                                    ?.furniture_images?.[0]
                                                    ?.imageUrl || "")
                                                }
                                                alt="assets"
                                                onError={(e) => {
                                                  e.target.src = FurnitureBackImg;
                                                }}
                                                style={{
                                                  width: "50px",
                                                  height: "50px",
                                                  objectFit: "cover",
                                                }}
                                              />{" "}
                                              {item.furniture_data?.name}
                                            </td>
                                            <td>{item.quantity}</td>
                                            <td>${item.price}</td>
                                          </tr>
                                        ),
                                      )}
                                    </>
                                  )}

                                {/* ✅ Show delivery, city, and grand total once at the bottom */}
                                <tr>
                                  <td
                                    colSpan={3}
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Total:
                                  </td>
                                  <td>
                                    $
                                    {cartData?.mainCart.furnitureCarts?.reduce(
                                      (acc, cart) =>
                                        acc +
                                        cart.quantity *
                                        cart.furniture_data.price,
                                      0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan={3}
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Delivery Price:
                                  </td>
                                  <td>
                                    $
                                    {deliveryDetail?.delivery_price +
                                      deliveryDetail?.city_price || 0}
                                  </td>
                                </tr>

                                {/* <tr>
                                  <td
                                    colSpan={3}
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    City Price:
                                  </td>
                                  <td>${deliveryDetail?.city_price || 0}</td>
                                </tr> */}

                                <tr>
                                  <td
                                    colSpan={3}
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Grand Total:
                                  </td>
                                  <td style={{ fontWeight: "bold" }}>
                                    $
                                    {cartData?.mainCart.furnitureCarts?.reduce(
                                      (acc, cart) =>
                                        acc +
                                        cart.quantity *
                                        cart.furniture_data.price,
                                      0,
                                    ) +
                                      (deliveryDetail?.delivery_price || 0) +
                                      (deliveryDetail?.city_price || 0)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {(user?.currentRole === "relo" ||
                    user?.currentRole == "tenant") &&
                    !finalCartData?.parent_cart_id && (
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button ${tenantList?.length === 0 ? "" : "collapsed"
                              }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse3"
                            aria-expanded={tenantList?.length >= 0}
                            aria-controls="collapse3"
                          >
                            <ul>
                              <li>
                                <img src={Cartplan1} alt="assets" /> Tenant
                                Details
                              </li>
                            </ul>
                          </button>
                        </h2>
                        <div
                          id="collapse3"
                          className={`accordion-collapse collapse ${tenantList?.length >= 0 ? "show" : ""
                            }`}
                          data-bs-parent="#accordionExample"
                        >
                          {tenantList?.length > 0 || inputTenant ? (
                            <>
                              <div className="accordion-body">
                                <div className="table-responsive">
                                  <table className="table m-0">
                                    <thead>
                                      <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Age</th>
                                        <th scope="col">Gender</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Email</th>
                                        {/* <th scope="col">Document</th> */}
                                        <th scope="col">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {tenantList.map((tenantData, key) => (
                                        <tr key={key}>
                                          <td>{key + 1}</td>
                                          <td>
                                            {isEditing === key ? (
                                              <>
                                                <input
                                                  type="text"
                                                  className="tenant-input-list form-control"
                                                  required={true}
                                                  value={editedTenant?.name}
                                                  onChange={(e) => {
                                                    setEditedTenant({
                                                      ...editedTenant,
                                                      name: e.target.value,
                                                    });
                                                  }}
                                                />
                                                {requiredField?.name && (
                                                  <div style={{ color: "red" }}>
                                                    {requiredField?.name}
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              tenantData.name
                                            )}
                                          </td>
                                          <td>
                                            {isEditing === key ? (
                                              <input
                                                type="number"
                                                className="tenant-input-list form-control"
                                                value={editedTenant.age}
                                                min={1}
                                                max={110}
                                                required={!tenantData.length}
                                                onChange={(e) =>
                                                  setEditedTenant({
                                                    ...editedTenant,
                                                    age: e.target.value,
                                                  })
                                                }
                                              />
                                            ) : (
                                              tenantData.age
                                            )}
                                          </td>
                                          <td>
                                            {isEditing === key ? (
                                              <select
                                                value={editedTenant.gender}
                                                className="tenant-input-list form-control"
                                                required={!tenantData.length}
                                                onChange={(e) =>
                                                  setEditedTenant({
                                                    ...editedTenant,
                                                    gender: e.target.value,
                                                  })
                                                }
                                              >
                                                <option value="">
                                                  Select Gender
                                                </option>
                                                <option value="male">
                                                  Male
                                                </option>
                                                <option value="female">
                                                  Female
                                                </option>
                                                <option value="other">
                                                  Other
                                                </option>
                                              </select>
                                            ) : (
                                              tenantData.gender
                                            )}
                                          </td>
                                          <td>
                                            {isEditing === key ? (
                                              <>
                                                <input
                                                  type="text"
                                                  className="tenant-input-list form-control"
                                                  value={editedTenant.phone}
                                                  onChange={(e) => {
                                                    setEditedTenant({
                                                      ...editedTenant,
                                                      phone: e.target.value,
                                                    });
                                                  }}
                                                />
                                                {requiredField?.phone && (
                                                  <div style={{ color: "red" }}>
                                                    {requiredField?.phone}
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              tenantData.phone
                                            )}
                                          </td>
                                          <td>
                                            {isEditing === key ? (
                                              <>
                                                <input
                                                  type="text"
                                                  className="tenant-input-list form-control"
                                                  value={editedTenant.email}
                                                  onChange={(e) => {
                                                    setEditedTenant({
                                                      ...editedTenant,
                                                      email: e.target.value,
                                                    });
                                                  }}
                                                />
                                                {requiredField?.email && (
                                                  <div style={{ color: "red" }}>
                                                    {requiredField?.email}
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              tenantData.email
                                            )}
                                          </td>
                                          {/* <td>
                                            <div className="Neon Neon-theme-dragdropbox">
                                              <input
                                                name="files[]"
                                                id="filer_input2"
                                                accept=".jpg, .png, .jpeg,.pdf,.docx"
                                                type="file"
                                                required={!tenantData.length}
                                                disabled={
                                                  isEditing !== key ||
                                                  !!tenantData.document ||
                                                  !!tenantData.id
                                                }
                                                onChange={handleFileChange}
                                              />
                                              <div className="AddTenant-input-dragDrop">
                                                <div className="Neon-input-inner">
                                                  <div className="Neon-input-icon">
                                                    <img
                                                      src={
                                                        tenantData?.document
                                                          ? `${
                                                              import.meta.env
                                                                .VITE_APP_BASE_URL
                                                            }/${
                                                              tenantData?.document
                                                            }`
                                                          : uploadImage
                                                      }
                                                      disabled={tenantData?.id}
                                                      alt="upload"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </td> */}
                                          <td>
                                            {isEditing === key ? (
                                              <>
                                                {isDisabledButtonIcons ? (
                                                  <div>
                                                    <Spinner />
                                                  </div>
                                                ) : (
                                                  <button
                                                    className="proceed-btn"
                                                    disabled={
                                                      isDisabledButtonIcons
                                                    }
                                                    onClick={() =>
                                                      handleUpdateTenant(key)
                                                    }
                                                  >
                                                    Update
                                                  </button>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <button
                                                  className="tenantadd-edit-button"
                                                  onClick={() =>
                                                    handleEditTenant(key)
                                                  }
                                                >
                                                  <i class="fa fa-solid fa-pen-to-square"></i>
                                                </button>
                                                <button
                                                  className="tenantadd-delete-button"
                                                  onClick={() =>
                                                    handleDeleteTenant(key)
                                                  }
                                                >
                                                  <i class="fa fa-solid fa-trash"></i>
                                                </button>
                                              </>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                      {tenantList.length < 5 &&
                                        !isEditing &&
                                        inputTenant && (
                                          <tr>
                                            <td>{tenantList.length + 1}</td>
                                            <td>
                                              <input
                                                type="text"
                                                className="tenant-input-list form-control"
                                                placeholder="Enter First and last Name"
                                                value={newTenant.name || ""}
                                                onChange={(e) => {
                                                  setNewTenant({
                                                    ...newTenant,
                                                    name: e.target.value,
                                                  });
                                                  clearError("name");
                                                }}
                                              />
                                              {requiredField?.name && (
                                                <div style={{ color: "red" }}>
                                                  {requiredField?.name}
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                min={1}
                                                max={110}
                                                className="tenant-input-list form-control"
                                                placeholder="Age"
                                                value={newTenant.age}
                                                onChange={(e) => {
                                                  setNewTenant({
                                                    ...newTenant,
                                                    age: e.target.value,
                                                  });
                                                  clearError("age");
                                                }}
                                              />
                                              {requiredField?.age && (
                                                <div style={{ color: "red" }}>
                                                  {requiredField?.age}
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <select
                                                className="form-control"
                                                value={newTenant.gender}
                                                onChange={(e) => {
                                                  setNewTenant({
                                                    ...newTenant,
                                                    gender: e.target.value,
                                                  });
                                                  clearError("gender");
                                                }}
                                              >
                                                <option value="">
                                                  Select Gender
                                                </option>
                                                <option value="male">
                                                  Male
                                                </option>
                                                <option value="female">
                                                  Female
                                                </option>
                                                <option value="other">
                                                  Other
                                                </option>
                                              </select>
                                              {requiredField?.gender && (
                                                <div style={{ color: "red" }}>
                                                  {requiredField?.gender}
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Enter Contact"
                                                value={newTenant?.phone}
                                                onChange={(e) => {
                                                  setNewTenant({
                                                    ...newTenant,
                                                    phone: e.target.value,
                                                  });
                                                  clearError("phone");
                                                }}
                                              />

                                              {requiredField?.phone && (
                                                <div style={{ color: "red" }}>
                                                  {requiredField?.phone}
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Enter email"
                                                value={newTenant?.email}
                                                onChange={(e) => {
                                                  setNewTenant({
                                                    ...newTenant,
                                                    email: e.target.value,
                                                  });
                                                  clearError("email");
                                                }}
                                              />
                                              {requiredField?.email && (
                                                <div style={{ color: "red" }}>
                                                  {requiredField?.email}
                                                </div>
                                              )}
                                            </td>
                                            {/* <td>
                                              <div className="Neon Neon-theme-dragdropbox ">
                                                <input
                                                  className="tenant-input-list-upload"
                                                  name="files[]"
                                                  id="filer_input2"
                                                  accept=".jpg, .png, .jpeg"
                                                  type="file"
                                                  onChange={handleFileChange}
                                                />
                                                <div className="AddTenant-input-dragDrop">
                                                  <div className="Neon-input-inner">
                                                    <div className="Neon-input-icon">
                                                      <img
                                                        src={
                                                          urlData || uploadImage
                                                        }
                                                        alt="edit"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {requiredField?.document && (
                                                <div style={{ color: "red" }}>
                                                  {requiredField?.document}
                                                </div>
                                              )}
                                            </td> */}
                                            <td className="br_btn amenit">
                                              {isDisabledButtonIcons ? (
                                                <div>
                                                  {" "}
                                                  <Spinner />
                                                </div> // This is your loading spinner
                                              ) : (
                                                <button
                                                  type="button"
                                                  disabled={
                                                    isDisabledButtonIcons
                                                  }
                                                  onClick={() =>
                                                    handleAddTenant()
                                                  }
                                                >
                                                  Add
                                                  {isDisabledButtonIcons}
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        )}
                                      {user?.currentRole === "relo" &&
                                        tenantList.length === 0 &&
                                        !finalCartData?.parent_cart_id && (
                                          <tr>
                                            <td
                                              colSpan="12"
                                              className="text-center text-danger"
                                            >
                                              Please add at least one tenant
                                              before proceeding to checkout
                                            </td>
                                          </tr>
                                        )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          ) : (
                            <p className="text-center">No tenants available.</p>
                          )}

                          {/* {tenantList.length < 4 &&
                            isEditing !== 0 &&
                            isEditing === null && (
                              <div>
                                <button
                                  className="proceed-btn btn-primary-add-tenant"
                                  disabled={isDisabledButtonIcons}
                                  onClick={() => {
                                    setIsEditing(null);
                                    setInputTenant((prevState) => !prevState); // Toggle form visibility
                                  }}
                                >
                                  Add Tenant
                                </button>
                              </div>
                            )} */}
                          {isTenantList && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                textAlign: "center",
                                marginTop: "2rem",
                                marginBottom: "2rem",
                              }}
                            >
                              To proceed, at least one tenant must have all
                              fields filled out.
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <h4>Cart Total</h4>
                <div className="sub-total-new">
                  <ul>
                    <li>
                      <span
                        style={{ fontWeight: "bold", color: "rgb(17 34 17)" }}
                      >
                        Sub total ( monthly){" "}
                        <i
                          title="Rent + Cleaning"
                          class="fa-solid fa-circle-info"
                        ></i>{" "}
                        :
                      </span>
                      <span>${finalCartData?.subTotalWithoutBookingFee}</span>
                    </li>
                    <li>
                      Security Fee (One time Non-Refundable) :{" "}
                      <span>${finalCartData?.non_refundable_fee}</span>
                    </li>
                    <li>
                      Security Insurance (Monthly) :{" "}
                      <span>${finalCartData?.security_price}</span>
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold", color: "rgb(17 34 17)" }}
                      >
                        Total Booking Fee{" "}
                        <i
                          title={`${bookingCharges}% of Monthly Rental fee`}
                          class="fa-solid fa-circle-info"
                        ></i>{" "}
                        :
                      </span>

                      <span>
                        ${" "}
                        {(
                          (Number(finalCartData?.house_price || 0) *
                            Number(bookingCharges)) /
                          100
                        ).toFixed(2)}
                        {/* {isChecked
                          ? (
                              (Number(finalCartData?.house_price || 0) *
                                Number(bookingCharges)) /
                              100
                            ).toFixed(2)
                          : (
                              (Number(finalCartData?.house_price || 0) *
                                (Number(finalCartData?.house_price || 0) / 30) *
                                noOfRemaingDays *
                                Number(bookingCharges)) /
                              100
                            ).toFixed(2)} */}
                      </span>
                    </li>
                    <li>
                      <span
                        style={{ fontWeight: "bold", color: "rgb(17 34 17)" }}
                      >
                        Total Amount : ( {noOfMonths}{" "}
                        {noOfMonths === 1 ? "Month" : "Months"}{" "}
                        {noOfRemaingDays > 0 &&
                          `and ${noOfRemaingDays} Day${noOfRemaingDays !== 1 ? "s" : ""
                          }`}{" "}
                        )
                        <i
                          title={`Rent + Cleaning + Booking Fee + Security Insurance`}
                          class="fa-solid fa-circle-info"
                        ></i>
                      </span>

                      <span>${totalAmount}</span>
                    </li>
                    {/* {!isChecked && (
                      <li>
                        Include Booking Charges : <span>${proceedAmount}</span>
                      </li>
                    )} */}
                  </ul>

                  {isChecked && (
                    <>
                      <div className="description-heading">
                        Monthly Rent Amount
                      </div>

                      <ul className="month-rent">
                        {monthlypay.map((element, i) => (
                          <li key={i}>
                            {element.month}
                            <span>${element.amount}</span>
                          </li>
                        ))}
                        {/* <li>
                          Include Booking Charges :{" "}
                          <span>${proceedAmount}</span>
                        </li> */}
                      </ul>
                    </>
                  )}

                  <div className="description-heading">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={
                          !isChecked ||
                          (noOfMonths === 1 && noOfRemaingDays === 0)
                        } // Checked by default and checked when condition is met
                        disabled={noOfMonths === 1 && noOfRemaingDays === 0}
                        onChange={handleCheckboxChange}
                        id="flexCheckDefault3"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault3"
                      >
                        Pay Full Amount
                      </label>
                    </div>
                  </div>
                  <div className="term-condition-checkbox">
                    <div className="form-check">
                      <input
                        className={`form-check-input ${termsError ? "is-invalid" : ""
                          }`}
                        type="checkbox"
                        checked={acceptTerms}
                        onChange={(e) => {
                          setAcceptTerms(e.target.checked);
                          if (e.target.checked) setTermsError(false);
                        }}
                        id="flexCheckDefault3"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault3"
                      >
                        By selecting this checkbox, I agree to the{" "}
                        <Link
                          to="/booking-terms"
                          className="text-decoration-underline"
                        >
                          bookings terms
                        </Link>{" "}
                        and the{" "}
                        <Link
                          to="/terms-condition"
                          className="text-decoration-underline"
                        >
                          updated Terms of Service
                        </Link>{" "}
                        View{" "}
                        <Link
                          to="/privacy-policy"
                          className="text-decoration-underline"
                        >
                          Privacy Policy
                        </Link>
                        .
                      </label>
                      {/* <label className="form-check-label">
                        By selecting this checkbox, I agree to the{" "}
                        <span
                          className="text-decoration-underline cursor-pointer term_privacy"
                          onClick={() => setBookingTermsModal(true)}
                        >
                          booking terms
                        </span>{" "}
                        and the{" "}
                        <span
                          className="text-decoration-underline cursor-pointer term_privacy"
                          onClick={() => setTermConModal(true)}
                        >
                          updated Terms of Service
                        </span>{" "}
                        View{" "}
                        <span
                          className="text-decoration-underline cursor-pointer term_privacy"
                          onClick={() => setPrivacyModal(true)}
                        >
                          Privacy Policy
                        </span>
                        .
                      </label> */}
                    </div>
                  </div>
                  <button
                    className="proceed-btn  d-flex align-items-center justify-content-center"
                    onClick={handleProceedCheckout}
                    disabled={
                      isDisabledButton ||
                      (user?.currentRole === "relo" &&
                        !tenantList.length &&
                        !finalCartData?.parent_cart_id) ||
                      isTenantList
                    }
                  >
                    {isDisabledButton ? (
                      <Loader />
                    ) : (
                      `Proceed to Checkout: ${parseFloat(proceedAmount).toFixed(
                        2,
                      )}`
                    )}
                  </button>
                  <ModalComponent
                    showModal={showModal}
                    setShowModal={setShowModal}
                    handleCloseModal={handleCloseModal}
                    cardData={cardData}
                    FetchCardData={FetchData}
                    totalAmount={parseFloat(proceedAmount).toFixed(2)}
                    cartId={finalCartData?.cartId}
                    subscription_type={subscriptionType}
                    housePrice={finalCartData?.house_price}
                    setIsDisabledButton={setIsDisabledButton}
                    monthlypay={monthlypay}
                    paymentBreakdown={paymentBreakdown}
                  ></ModalComponent>
                </div>
              </div>
            </div>
          ) : (
            // <div className="d-flex justify-content-center">
            //   <Spinner />
            // </div>

            <div className="eye-loader-frame m-5 p-5">
              <div className="eye-loader-spinner"></div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default AllDataInCart;
